<template>
  <!-- 客户投诉案例：按相同型号或当前客户筛选历史投诉。 -->
  <span>
    <AButton type="primary" @click="open">客户投诉案例</AButton>
    <XModal ref="modal" title="客户投诉案例" :ok="ok" :cancel-btn="false" :width="850">
      <div class="notice">投诉记录仅供本次检验参考，不改变当前检验结果。</div>
      <div class="filters">
        <button type="button" class="filter-button" :class="{ active: scope === 'same' }"
          @click="changeScope('same')">相同产品 / 型号</button>
        <button type="button" class="filter-button" :class="{ active: scope === 'customer' }"
          @click="changeScope('customer')">该客户全部</button>
      </div>
      <ASpin v-if="loading" class="loading" />
      <template v-else>
        <p class="case-summary">共 {{ cases.length }} 条投诉记录 · {{ scopeSummary }}</p>
        <section v-if="cases.length" class="case-list">
          <article v-for="(item, index) in cases" :key="caseKey(item, index)" class="case-card"
            :class="{ expanded: isExpanded(item, index) }">
            <header class="case-header">
              <div class="case-heading">
                <h3>{{ caseTitle(item) }}</h3>
                <p>{{ caseMeta(item) }}</p>
              </div>
              <div class="case-actions">
                <span class="case-badge">{{ scope === 'same' ? '相同型号' : '该客户' }}</span>
                <button type="button" class="detail-toggle" @click="toggleCase(item, index)">
                  {{ isExpanded(item, index) ? '收起详情 −' : '展开详情 +' }}
                </button>
              </div>
            </header>
            <div v-if="isExpanded(item, index)" class="case-detail">
              <div class="detail-row"><span>投诉描述</span><p>{{ item.problem || item.complaintContent || '-' }}</p></div>
              <div class="detail-row"><span>原因分析</span><p>{{ item.cause || item.causeAnalysis || '-' }}</p></div>
              <div class="detail-row"><span>处理结果</span><p>{{ item.result || item.handleResult || '-' }}</p></div>
              <div class="detail-row"><span>投诉图片</span><p class="attachment">{{ attachmentText(item) }}</p></div>
              <div class="focus"><b>检验关注：</b>{{ item.focus || item.inspectionFocus || '-' }}</div>
            </div>
          </article>
        </section>
        <div v-else class="empty">暂无投诉记录</div>
      </template>
    </XModal>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import { orderCustomer, orderModel } from '@api'

export default {
  data() {
    return {
      scope: "same",
      loading: false,
      cases: [],
      requestId: 0,
      expandedCaseKey: null,
    };
  },
  computed: {
    ...mapGetters(["getWorkOrder"]),
    scopeSummary() {
      const order = this.getWorkOrder;
      const model = order.model || order.modelName || order.productModel || order.orderName || "-";
      return this.scope === "same" ? `型号 ${model}` : `客户 ${order.customer || "-"}`;
    },
  },
  methods: {
    async open() {
      if (!this.getWorkOrder.productionOrderId) {
        this.$message.warning("请先选择巡检任务。");
        return;
      }

      this.$refs.modal.open();
      this.loadCases();
    },
    // XModal 确认按钮仅关闭投诉案例窗口。
    ok() {
      this.$refs.modal.cancel();
    },
    // 切换筛选项时，根据当前生产订单重新获取对应的投诉记录。
    changeScope(scope) {
      if (this.scope === scope) return;
      this.scope = scope;
      this.loadCases();
    },
    async loadCases() {
      const requestId = ++this.requestId;
      const productionOrderId = this.getWorkOrder.productionOrderId;
      if (!productionOrderId) return;

      this.loading = true;
      this.cases = [];
      this.expandedCaseKey = null;
      try {
        const response = this.scope === "same"
          ? await orderModel(productionOrderId)
          : await orderCustomer(productionOrderId);
        if (requestId !== this.requestId || productionOrderId !== this.getWorkOrder.productionOrderId) return;

        this.cases = this.responseList(response);
        this.expandedCaseKey = this.cases.length ? this.caseKey(this.cases[0], 0) : null;
      } catch (error) {
        if (requestId === this.requestId) {
          this.$message.error("投诉记录加载失败，请稍后重试。");
        }
      } finally {
        if (requestId === this.requestId) {
          this.loading = false;
        }
      }
    },
    responseList(response) {
      const data = response.data || response;
      return Array.isArray(data) ? data : Array.isArray(data.data) ? data.data : [];
    },
    caseTitle(item) {
      return item.title || item.complaintTitle || item.complaintContent || "客户投诉";
    },
    caseMeta(item) {
      return [item.date || item.createDate, item.order || item.orderCode, item.model || item.orderName]
        .filter(Boolean)
        .join(" · ");
    },
    caseKey(item, index) {
      return String(item.id || item.complaintId || index);
    },
    isExpanded(item, index) {
      return this.expandedCaseKey === this.caseKey(item, index);
    },
    // 单次仅展开一条，方便在工位端快速查看重点投诉记录。
    toggleCase(item, index) {
      const key = this.caseKey(item, index);
      this.expandedCaseKey = this.expandedCaseKey === key ? null : key;
    },
    attachmentText(item) {
      const photos = Array.isArray(item.photoList) ? item.photoList : [];
      if (photos.length) return `共 ${photos.length} 张投诉图片`;
      return item.photoUrl || item.imageUrl || "未提供投诉图片附件";
    },
  },
};
</script>

<style lang="less" scoped>
.notice {
  padding: 11px 15px;
  margin-bottom: 18px;
  color: #81521b;
  font-size: 14px;
  background: #fff6e6;
  border-left: 4px solid #dd9b32;
  border-radius: 7px;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 12px 0;
}

.filter-button {
  min-height: 48px;
  padding: 0 18px;
  color: #294462;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  background: #fff;
  border: 1px solid #c6d7e8;
  border-radius: 9px;
}

.filter-button.active {
  color: #fff;
  background: #176ed0;
  border-color: #176ed0;
}

.loading {
  display: block;
  padding: 36px 0;
  text-align: center;
}

.case-summary {
  margin: 14px 0;
  color: #5f7893;
  font-size: 14px;
}

.case-list {
  display: grid;
  gap: 14px;
}

.case-card {
  overflow: hidden;
  background: #fff;
  border: 1px solid #cdddeb;
  border-radius: 12px;
}

.case-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  background: #f1f7fe;
}

.case-heading h3,
.case-heading p {
  margin: 0;
}

.case-heading h3 {
  color: #1f3852;
  font-size: 18px;
}

.case-heading p {
  margin-top: 5px;
  color: #617b95;
  font-size: 14px;
  font-weight: 600;
}

.case-actions {
  display: flex;
  flex: none;
  align-items: center;
  gap: 14px;
}

.case-badge {
  padding: 5px 9px;
  color: #176ed0;
  font-size: 13px;
  font-weight: 600;
  background: #e4f1ff;
  border-radius: 7px;
}

.detail-toggle {
  padding: 4px 0;
  color: #176ed0;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  background: transparent;
  border: 0;
}

.case-detail {
  padding: 16px;
}

.detail-row {
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr);
  gap: 14px;
  margin-bottom: 13px;
}

.detail-row > span {
  color: #67809a;
}

.detail-row p {
  margin: 0;
  color: #263f59;
  line-height: 1.55;
}

.attachment {
  padding: 10px 12px;
  color: #69819a !important;
  background: #f1f5f9;
  border-radius: 8px;
}

.focus {
  padding: 12px;
  margin-top: 2px;
  color: #835513;
  background: #fff5df;
  border-radius: 8px;
}

.empty {
  padding: 28px 16px;
  color: #62758a;
  text-align: center;
  background: #f3f6fa;
  border: 1px dashed #bacbdb;
  border-radius: 8px;
}

@media (max-width: 700px) {
  .case-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .case-actions {
    width: 100%;
    justify-content: space-between;
  }

  .detail-row {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}
</style>
